<template>
  <div class="black-wrap">
    <div v-if="loading" class="loading-wrap">
      <i class="el-icon-loading"></i>
    </div>
    <div v-else-if="blackList.length" class="black-list">
      <div
        v-for="(b, i) in blackList"
        :key="`black-${b.blackUuid}`"
        class="black-one"
      >
        <fps-avatar class="user-avatar" :src="b.avatarUrl" />
        <span class="nick-name">{{ b.nickname }}</span>
        <button class="cancel-black" :disabled="b.loading" @click="blackItem(b, i)">
          <i v-if="b.loading" class="el-icon-loading"></i>
          <span v-else>{{$t('components_userrelation_index_240')}}</span>
        </button>
      </div>
    </div>
    <div v-else class="no-black">
      <img src="~@/assets/image/background/no-black.png">
      <span>{{$t('upgrade_page_views_user_set_black_1054')}}</span>
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'

export default {
  data() {
    return {
      loading: true,
      blackList: [],
    }
  },
  created() {
    this.getBlackUser()
  },
  methods: {
    getBlackUser() {
      this.$http.post('/user/black/list', {
        pageIndex: 0,
        pageSize: 10000,
      }).then(({ data: { pageContent } }) => {
        this.blackList = pageContent
        this.loading = false
      })
    },
    blackItem(info, i) {
      const { blackUuid, loading } = info
      if (loading) return
      info.loading = true
      this.$set(this.blackList, i, info)
      this.$http.post('/user/black/inactive', {
        blackUuid,
      }).then(() => {
        this.$message.success(i18n.t('upgrade_page_views_user_set_black_1055'))
        this.blackList.splice(i, 1)
      }).catch(() => {
        info.loading = false
        this.$set(this.blackList, i, info)
      })
    },
  }
}
</script>
<style lang="scss" scoped>
  .loading-wrap {
    @include flex;
    height: 100px;
    font-size: 40px;
  }
  .black-list {
    padding: 24px 0 0;
    @include flex(space-between, flex-start);
    flex-wrap: wrap;
    .black-one {
      width: 482px;
      height: 100px;
      margin-top: 16px;
      background: #FFFFFF;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      @include flex;
      padding: 0 20px;
      .user-avatar {
        width: 50px;
        height: 50px;
      }
      .nick-name {
        flex: 1;
        margin-left: 10px;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        /* identical to box height, or 125% */

        letter-spacing: -0.3px;

        color: #333333;
      }
      .cancel-black {
        width: 80px;
        height: 32px;
        border-radius: 20px;
        background: $color-split;
        font-size: 13px;
        line-height: 32px;
        text-align: center;
        letter-spacing: -0.000319808px;
        color: $color-gray-2;
        &:disabled {
          background: $color-split !important;
          color: $color-gray-2 !important;
        }
      }
    }
  }
  .no-black {
    @include flex(flex-start, center, column);
    img {
      margin: 108px 0 24px;
      width: 140px;
    }
    span {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.00025px;
      color: $color-gray-2;
    }
  }
</style>
